module.exports = __webpack_public_path__ + "static/media/josepht.5c5c6623.jpg";